module.exports = __webpack_public_path__ + "img/Logo_itra_Simple_N blanc.fc504318.png";